//const LOC = window.location.pathname;
//const DIR = LOC.substring(0, LOC.lastIndexOf("/"));
//const IMG_URI = "./static/images/";
import { IMG_DIR } from "@/services/config.service";

const ImageServiceMethods = {
  convertToBase641(e) {
    const file = e;

    if (file != undefined || file != null) {
      this.imageName = file.name;
      if (this.imageName.lastIndexOf(".") <= 0) {
        return;
      }
      const fr = new FileReader();
      fr.readAsDataURL(file);
      fr.addEventListener("load", () => {
        return fr.result;
      });
    } else {
      return "";
    }
  },

  convertToBase64(file) {
    if (file != undefined || file != null) {
      const fr = new FileReader();

      return new Promise((resolve, reject) => {
        fr.onerror = () => {
          fr.abort();
          reject(new DOMException("Problem parsing input file."));
        };

        fr.onload = () => {
          resolve(fr.result);
        };
        fr.readAsDataURL(file);
      });
    } else {
      return null;
    }
  }
};

export const getImage = base64Image => {
  if (base64Image) {
    return "data:image/png;base64," + base64Image;
  } else {
    return null;
  }
};

export const getBase64Image = async file => {
  try {
    const fileContents = await ImageServiceMethods.convertToBase64(file);
    return fileContents;
    //console.log(fileContents);
  } catch (e) {
    console.warn(e.message);
    return e.message;
  }
};

export const getPublicImageUrl = () => {
  return IMG_DIR;
};

export default { getImage, getBase64Image, getPublicImageUrl };
